import { render, staticRenderFns } from "./RoutesCalander.vue?vue&type=template&id=5d889474&"
import script from "./RoutesCalander.vue?vue&type=script&lang=js&"
export * from "./RoutesCalander.vue?vue&type=script&lang=js&"
import style0 from "./RoutesCalander.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports